import { render } from "./MSReflectionPanel.vue?vue&type=template&id=50ed34c3&scoped=true&ts=true"
import script from "./MSReflectionPanel.vue?vue&type=script&lang=ts"
export * from "./MSReflectionPanel.vue?vue&type=script&lang=ts"

import "./MSReflectionPanel.vue?vue&type=style&index=0&id=50ed34c3&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/mingaku/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50ed34c3"]])

export default __exports__